import script from "./Feed.vue?vue&type=script&setup=true&lang=js"
export * from "./Feed.vue?vue&type=script&setup=true&lang=js"

import "./Feed.vue?vue&type=style&index=0&id=f9a1666e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9a1666e"]])

export default __exports__